import skrollTop from 'skrolltop';
import { getOffset } from './_getOffset'
import './_easings'

// スムーススクロール時に対象セクションの上に残す余白
const SCROLL_OFFSET = 32;

export function scrollNav() {
  const scrollTrigger = document.querySelectorAll('[data-scroll-trigger]');
  const scrollTarget = document.querySelectorAll('[data-scroll-target]');
  const minusEl = document.querySelector('.header');

  const scrollTriggerMap = {};
  let scrollTargetArr = [];
  let minusElHeight = 0;
  let scrollingTimer = null;

  if(scrollTrigger.length && scrollTarget.length) {
    for (let i = 0; i < scrollTrigger.length; i++) {
      const triggerName = scrollTrigger[i].dataset.scrollTrigger;
      scrollTriggerMap[triggerName] = scrollTrigger[i];
    }

    const SCROLL_TOP_POSITION = function() {
      scrollTargetArr = [];
      for (let i = 0; i < scrollTarget.length; i++) {
        const target = scrollTarget[i];
        const targetScrollOffset = getOffset(target);
        if(minusEl) minusElHeight = minusEl.clientHeight;
        const targetscrollTarget = targetScrollOffset.top - minusElHeight - SCROLL_OFFSET - 1;
        const targetScrollBottom = targetscrollTarget + target.clientHeight + minusElHeight + SCROLL_OFFSET + 1;
        scrollTargetArr[i] = [targetscrollTarget, targetScrollBottom];
      }
    }

    const SCROLL_POSITION_CHECK = function() {
      const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      for (let i = 0; i < scrollTargetArr.length; i++) {
        const thisArr = scrollTargetArr[i];
        const thisscrollTarget = thisArr[0];
        const thisScrollBottom = thisArr[1];

        const thisScroll = scrollTarget[i];
        const thisScrollName = thisScroll.dataset.scrollTarget;
        const current = scrollTriggerMap[thisScrollName];

        if(current) {
          if(thisscrollTarget < scTop && thisScrollBottom > scTop) {
            current.classList.add('is-current');
          } else {
            current.classList.remove('is-current');
          }
        }
      }
    }

    // 指定セクションへスムーススクロール。
    // 現在のページに対象が存在すれば true、存在しなければ false を返す。
    const SCROLL_TO_TARGET = function(name) {
      const target = document.querySelector(`[data-scroll-target=${name}]`);
      if(!target) return false;
      clearTimeout(scrollingTimer);
      document.body.classList.add('is-click-scrolling');
      SCROLL_TOP_POSITION();
      SCROLL_POSITION_CHECK();
      const targetOffset = getOffset(target);
      if(minusEl) minusElHeight = minusEl.clientHeight;
      let targetOffsetTop = targetOffset.top - minusElHeight - SCROLL_OFFSET;
      if(targetOffsetTop < 0) { targetOffsetTop = 0; }
      skrollTop.scrollTo({
        to: targetOffsetTop,
        easing: window.easings.easeInOutQuint,
        duration: 1200
      });
      scrollingTimer = setTimeout(() => {
        document.body.classList.remove('is-click-scrolling');
      }, 1200);
      document.body.classList.remove('is-nav-active');
      return true;
    }

    for (let i = 0; i < scrollTrigger.length; i++) {
      const _scrollTrigger = scrollTrigger[i];
      _scrollTrigger.addEventListener('click', (e) => {
        const thisScrollName = _scrollTrigger.dataset.scrollTrigger;
        // 対象セクションが現在のページに存在する場合のみページ内スクロール。
        // 存在しない場合は href（home + アンカー）へ遷移させる。
        if(SCROLL_TO_TARGET(thisScrollName)) {
          e.preventDefault();
        }
      });
    }

    window.addEventListener('resize', () => {
      SCROLL_TOP_POSITION();
      SCROLL_POSITION_CHECK();
    });

    window.addEventListener('orientationchange', () => {
      SCROLL_TOP_POSITION();
      SCROLL_POSITION_CHECK();
    });

    window.addEventListener('scroll', SCROLL_POSITION_CHECK);

    SCROLL_TOP_POSITION();
    SCROLL_POSITION_CHECK();

    // home にアンカー付きで遷移してきた場合、該当セクションへスムーススクロール。
    // 画像読み込み後の正確な位置を使うため load 後に実行する。
    if(window.location.hash) {
      const hashName = window.location.hash.replace('#', '');
      window.addEventListener('load', () => {
        SCROLL_TO_TARGET(hashName);
      });
    }
  }
}
